import "core-js/modules/es.array.push.js";
import { WOW } from "wowjs";
import { cowContactList, queryImgList, selectUserInfoById, queryCount, addNote } from "../../../request/api";
export default {
  watch: {
    $route: {
      handler: function (val) {
        this.watchRoute(val);
      },
      deep: true
    }
  },
  inject: ["reload"],
  provide() {
    return {
      getnavId: this.getnavId
    };
  },
  data() {
    return {
      usernameremind: "",
      phoneemind: "",
      emailemind: "",
      consultationtesShow: "1",
      phone1: "0356210068",
      phone2: "4001006992",
      ruphone: "15364667403",
      navIndex: 10,
      loginShow: false,
      navShow: false,
      navShows: false,
      phoneshow: false,
      showPopupShow: false,
      list: [{
        navId: 0,
        url: "/home/index",
        name: "首页"
      },
      // { navId: 1, url: "/home/customize", name: "定制开发" },
      {
        navId: 2,
        url: "/home/template",
        name: "快速建站"
      }],
      lists: [{
        navId: 3,
        url: "/home/property",
        name: "知识产权"
      }, {
        navId: 4,
        url: "/home/about",
        name: "关于我们"
      }],
      id: window.sessionStorage.getItem("home_nav_index") || 0,
      logins: "登录",
      registers: "注册",
      personal: "个人中心",
      showLogin: true,
      showRegister: true,
      showpersonal: false,
      cowContactList: [],
      relation: {},
      personalcenter1: false,
      personalId: 0,
      quit: "",
      offer: "",
      record: "",
      technology: "",
      resume: "",
      queryImgList: [],
      head: "",
      headshow: true,
      headsshow: false,
      isTop: false,
      reload: this.reload,
      offset: null,
      backtopShow: false,
      viser: [],
      mobileTabShow: false,
      mobileList: [{
        url: "/home/index",
        name: "首页"
      }, {
        url: "/home/customize",
        name: "定制开发"
      }, {
        url: "/home/internetthings",
        name: "物联网开发"
      }, {
        url: "/home/template",
        name: "快速建站"
      }, {
        url: "/IDC",
        name: "IDC服务"
      }, {
        url: "/home/server",
        name: "服务器租赁"
      }, {
        url: "/home/domain",
        name: "域名注册及备案"
      }, {
        url: "/home/ssl",
        name: "SSL证书"
      }, {
        url: "/home/property",
        name: "知识产权"
      }, {
        url: "/home/about/brief",
        name: "关于我们"
      }],
      linkBox: [{
        img: require("../../../assets/mobileimg/Slice 431.png")
      }, {
        img: require("../../../assets/mobileimg/Slice 432.png")
      }],
      mobileId: 0,
      mobileCowContactList: [],
      mobileRelation: {},
      mobileQueryImgList: {},
      mobileNavShow: true,
      getlogos: require("../../../assets/mobileimg/Slice 449.png"),
      tabShow: true,
      consultatshow: false,
      consultatshowtwo: true,
      username: "",
      phone: "",
      email: "",
      note: "",
      seekadviceflage: false
    };
  },
  created() {
    /*  var _53code = document.createElement("script");
     _53code.src = "https://tb.53kf.com/code/code/a2378400489bed7ed60a8bfaf497ebb17/1";
     var s = document.getElementsByTagName("script")[0];
     s.parentNode.insertBefore(_53code, s); */
  },
  methods: {
    close() {
      this.consultationtesShow = "1";
      this.username = "";
      this.phone = "";
      this.email = "";
      this.note = "";
      this.usernameremind = "";
      this.phoneemind = "";
      this.emailemind = "";
      this.seekadviceflage = false;
    },
    getinput() {
      let reg = /^[\u4e00-\u9fa5]*$/;
      const regCN = /^(13[0-9]|14[01456879]|15[0-35-9]|16[2567]|17[0-8]|18[0-9]|19[0-35-9])\d{8}$/;
      const em = /^\w+((-\w+)|(\.\w+))*\@[A-Za-z0-9]+((\.|-)[A-Za-z0-9]+)*\.[A-Za-z0-9]+$/;
      console.log("输入内容");
      if (reg.test(this.username)) {
        this.usernameremind = "";
      }
      if (regCN.test(this.phone)) {
        this.phoneemind = "";
      }
      if (em.test(this.email)) {
        this.emailemind = "";
      }
      if (this.username == this.username || this.phone == this.phone || this.email == this.email || this.note == this.note) {
        this.consultatshow = true;
        this.consultatshowtwo = false;
      }
      if (this.username == "" || this.phone == "" || this.email == "" || this.note == "") {
        this.consultatshow = false;
        this.consultatshowtwo = true;
      }
    },
    submit() {
      let reg = /^[\u4e00-\u9fa5]*$/;
      const regCN = /^(13[0-9]|14[01456879]|15[0-35-9]|16[2567]|17[0-8]|18[0-9]|19[0-35-9])\d{8}$/;
      const em = /^\w+((-\w+)|(\.\w+))*\@[A-Za-z0-9]+((\.|-)[A-Za-z0-9]+)*\.[A-Za-z0-9]+$/;
      if (!reg.test(this.username)) {
        this.usernameremind = "请填正确填写您的中文姓名";
      } else if (!regCN.test(this.phone)) {
        this.phoneemind = "请填写正确的手机号";
      } else if (!em.test(this.email)) {
        this.emailemind = "请填写正确的邮箱";
      } else {
        addNote({
          action: "addNote",
          data: {
            username: this.username,
            phone: this.phone,
            email: this.email,
            note: this.note
          }
        }).then(res => {
          console.log(res);
          if (res.code == 200) {
            this.consultationtesShow = "2", this.username = "", this.phone = "", this.email = "", this.note = "";
          }
        });
      }
    },
    showPopup() {
      this.showPopupShow = true;
    },
    getphone() {
      this.phoneshow = true;
    },
    nophone() {
      this.phoneshow = false;
    },
    // 立即咨询
    seekadvice() {
      this.seekadviceflage = true;
      // this.$router.push("/home/contact")
      // window.open("https://tb.53kf.com/code/client/a2378400489bed7ed60a8bfaf497ebb17/1");
    },

    watchRoute(val) {
      if (val.path != "/mobile/delivery" && val.path != "/mobile/username") {
        sessionStorage.removeItem("notesusername");
      }
      if (val.path == "/home/index") {
        this.id = 0;
        sessionStorage.removeItem("mobilecaseindex");
        sessionStorage.removeItem("mobilecaseitemId");
        sessionStorage.removeItem("mobilecasetitle");
        sessionStorage.removeItem("mobilebusinessindex");
        sessionStorage.removeItem("mobilebusinesstitle");
        sessionStorage.removeItem("mobilebusinessid");
        sessionStorage.removeItem("allAppitemindex");
        sessionStorage.removeItem("allAppitemId");
        sessionStorage.removeItem("itemtitle");
        sessionStorage.removeItem("pcbusinesstitle");
        sessionStorage.removeItem("pcbusinessindex");
        sessionStorage.removeItem("pcbusinessid");
        /*      sessionStorage.removeItem("designindex");
                sessionStorage.removeItem("designId");
                sessionStorage.removeItem("designitemtitle"); */
      }

      if (val.path == "/home/domainseach") {
        this.tabShow = false;
      } else {
        this.tabShow = true;
      }
      if (val.path == "/home/customize") {
        this.id = 1;
        sessionStorage.removeItem("mobiledesignindex");
        sessionStorage.removeItem("mobiledesignitemId");
        sessionStorage.removeItem("mobiledesigntitle");
        sessionStorage.removeItem("mobilebusinessindex");
        sessionStorage.removeItem("mobilebusinesstitle");
        sessionStorage.removeItem("mobilebusinessid");
        sessionStorage.removeItem("pcbusinesstitle");
        sessionStorage.removeItem("pcbusinessindex");
        sessionStorage.removeItem("pcbusinessid");
        sessionStorage.removeItem("designindex");
        sessionStorage.removeItem("designId");
        sessionStorage.removeItem("designitemtitle");
      }
      if (val.path != "/home/customize" && val.path != "/home/allAPP" && val.path != "/home/APPitem") {
        sessionStorage.removeItem("allAppitemindex");
        sessionStorage.removeItem("allAppitemId");
        sessionStorage.removeItem("itemtitle");
        sessionStorage.removeItem("type");
      }
      if (val.path != "/home/index" && val.path != "/home/customize" && val.path != "/home/property" && val.path != "/home/allAPP" && val.path != "/home/APPitem" && val.path != "/home/billAppParticulars" && val.path != "/home/BILLitem") {
        sessionStorage.removeItem("designindex");
        sessionStorage.removeItem("designId");
        sessionStorage.removeItem("designitemtitle");
        sessionStorage.removeItem("deviselist");
        sessionStorage.removeItem("mobiledesignindex");
        sessionStorage.removeItem("mobiledesignitemId");
        sessionStorage.removeItem("mobiledesignbackground");
        sessionStorage.removeItem("mobiledesigntitle");
        sessionStorage.removeItem("mobilecaseindex");
        sessionStorage.removeItem("mobilecaseitemId");
        sessionStorage.removeItem("mobilecasetitle");
        sessionStorage.removeItem("mobilebusinessindex");
        sessionStorage.removeItem("mobilebusinesstitle");
        sessionStorage.removeItem("mobilebusinessid");
      }
      if (val.path == "/home/template") {
        this.id = 2;
      }
      if (val.path == "/IDC") {
        this.id = 5;
      }
      if (val.path == "/home/server") {
        this.id = 5;
      }
      if (val.path == "/home/domain") {
        this.id = 5;
      }
      if (val.path == "/home/ssl") {
        this.id = 5;
      }
      if (val.path == "/home/property") {
        this.id = 3;
        sessionStorage.removeItem("mobiledesignindex");
        sessionStorage.removeItem("mobiledesignitemId");
        sessionStorage.removeItem("mobiledesigntitle");
        sessionStorage.removeItem("mobilecaseindex");
        sessionStorage.removeItem("mobilecaseitemId");
        sessionStorage.removeItem("mobilecasetitle");
        sessionStorage.removeItem("designindex");
        sessionStorage.removeItem("designId");
        sessionStorage.removeItem("designitemtitle");
      }
      if (val.path == "/home/about") {
        this.id = 4;
      }
      if (val.path == "/home/about/brief") {
        this.id = 4;
        this.personalId = 1;
      }
      if (val.path == "/home/about/introduce") {
        this.id = 4;
        this.personalId = 1;
      }
      if (val.path == "/home/about/experience") {
        this.id = 4;
        this.personalId = 1;
      }
      if (val.path == "/home/about/leave") {
        this.id = 4;
        this.personalId = 1;
      }
      if (val.path == "/my") {
        sessionStorage.removeItem("home_nav_index");
        this.id = null;
      }
      if (["/home/sslTypeDetail", "/my", "/mobile/mypersonal", "/mobile/record", "/mobile/consulting", "/mobile/delivery"].includes(val.path)) {
        this.mobileNavShow = false;
      } else {
        this.mobileNavShow = true;
      }
    },
    getnavId(ids) {
      this.id = ids;
    },
    navtab(navId, index, url) {
      localStorage.removeItem("roll");
      this.id = navId;
      window.scrollTo({
        top: 0,
        left: 0
        // behavior: "smooth",
      });

      window.sessionStorage.setItem("home_nav_index", navId);
      sessionStorage.removeItem("about_tab_index");
      this.$router.push(url);
    },
    getlodinshow() {
      this.loginShow = !this.loginShow;
      this.mobileTabShow = false;
    },
    // 移动端跳转个人中心
    personalcenter() {
      this.$router.push({
        path: "/my",
        query: {
          ids: 0
        }
      });
    },
    nav(navId, index, url) {
      localStorage.removeItem("roll");
      this.id = navId;
      window.sessionStorage.setItem("home_nav_index", navId);
      this.$router.push(url);
    },
    //网站浏览量
    getqueryCount() {
      queryCount({
        action: "queryCount"
      }).then(res => {
        this.viser = res.data.countInfos;
      });
    },
    getnavShow() {
      this.navShow = !this.navShow;
    },
    // 定制开发展开
    getcustomization() {
      this.navShows = !this.navShows;
    },
    // logo跳转
    getlogo() {
      this.$router.push("/home/index");
      this.id = 0;
      //标记下面两行删除
      this.navIndex = "10";
      this.tabitem(this.mobileList[0].url, 0, "10");
    },
    // 登录
    login() {
      this.$router.push("/login");
    },
    // 注册
    register() {
      this.$router.push("/register");
    },
    // 个人中心
    getpersonal() {
      this.id = -1;
      if (this.$route.path == "/my") {
        this.$router.replace({
          path: "/my",
          query: {
            ids: 0
          }
        });
        this.reload();
      } else {
        this.$router.push({
          path: "/my",
          query: {
            ids: 0
          }
        });
      }
    },
    // 报价咨询
    getoffer() {
      this.id = -1;
      if (this.$route.path == "/my") {
        this.$router.replace({
          path: "/my",
          query: {
            ids: 1
          }
        });
        this.reload();
      } else {
        this.$router.push({
          path: "/my",
          query: {
            ids: 1
          }
        });
      }
    },
    // 技术咨询
    gettechnology() {
      this.id = -1;
      if (this.$route.path == "/my") {
        this.$router.replace({
          path: "/my",
          query: {
            ids: 2
          }
        });
        this.reload();
      } else {
        this.$router.push({
          path: "/my",
          query: {
            ids: 2
          }
        });
      }
    },
    // 资讯记录
    getrecord() {
      this.id = -1;
      if (this.$route.path == "/my") {
        this.$router.replace({
          path: "/my",
          query: {
            ids: 3
          }
        });
        this.reload();
      } else {
        this.$router.push({
          path: "/my",
          query: {
            ids: 3
          }
        });
      }
    },
    // 投递简历
    getresume() {
      this.id = -1;
      if (this.$route.path == "/my") {
        this.$router.replace({
          path: "/my",
          query: {
            ids: 4
          }
        });
        this.reload();
      } else {
        this.$router.push({
          path: "/my",
          query: {
            ids: 4
          }
        });
      }
    },
    concealpersonal() {
      this.personalcenter1 = true;
    },
    showpersonalFn() {
      this.personalcenter1 = false;
    },
    // 清除token
    eliminate() {
      this.$router.replace("/home/index");
      var storage = window.localStorage;
      storage.clear();
      location.reload();
    },
    getroll() {
      this.$nextTick(() => {
        var roll = document.body.scrollTop || document.documentElement.scrollTop || window.pageYOffset;
      });
    },
    wlwClick(index) {
      this.id = 1;
      window.sessionStorage.setItem("home_nav_index", 1);
      window.scrollTo({
        top: 350,
        left: 0
        // behavior: "smooth",
      });

      if (index == 0) {
        // 跳转服务器租赁
        this.$router.push("/home/internetthings");
      }
    },
    IDCClick(index) {
      this.id = 5;
      window.sessionStorage.setItem("home_nav_index", 5);
      window.scrollTo({
        top: 350,
        left: 0
        // behavior: "smooth",
      });

      if (index == 0) {
        // 跳转服务器租赁
        this.$router.push("/home/server");
      }
      if (index == 1) {
        // 跳转ssl
        this.$router.push("/home/ssl");
      }
      if (index == 2) {
        // 跳转域名注册
        this.$router.push("/home/domain");
      }
    },
    // 用户详情
    getselectUserInfoById() {
      let uid = localStorage.getItem("uid");
      selectUserInfoById({
        action: "selectUserInfoById",
        data: {
          id: uid
        }
      }).then(res => {
        this.head = res && res.data.avatar ? res.data.avatar : "";
        if (this.head !== "") {
          this.headshow = false;
          this.headsshow = true;
        } else {
          this.headshow = true;
          this.headsshow = false;
        }
      });
    },
    backToTop() {
      window.scrollTo(0, 0);
    },
    gowlw() {
      this.id = 1;
      window.sessionStorage.setItem("home_nav_index", 1);
      this.$router.push("/home/customize");
    },
    goIDC() {
      this.id = 5;
      window.sessionStorage.setItem("home_nav_index", 5);
      this.$router.push("/IDC");
    },
    // 移动端事件开始
    tab() {
      this.mobileTabShow = !this.mobileTabShow;
      this.loginShow = false;
      sessionStorage.removeItem("about_tab_index");
    },
    xxx() {
      if (this.mobileTabShow == true) {
        this.mobileTabShow = false;
      }
    },
    tabitem(url, index, id) {
      this.index = 0;
      sessionStorage.removeItem("about_tab_index");
      window.sessionStorage.setItem("home_nav_index", id);
      this.navIndex = id;
      this.mobileId = index;
      //  let token = localStorage.getItem("token")
      // if(url == "/my" && token == "") {
      //   this.$router.push("/logon")
      // } else
      if (url == "/my") {
        this.mobileTabShow = false;
        this.$router.push({
          path: "/my",
          query: {
            ids: 0
          }
        });
      } else if (this.mobileId == index) {
        this.$router.push(url);
        this.mobileTabShow = false;
      }
    },
    personalCenter() {
      this.$router.push("/my?ids=0");
    },
    mobileInit() {
      let token = localStorage.getItem("token");
      if (token) {
        this.mobileList = [{
          id: 1,
          url: "/home/index",
          name: "首页"
        }, {
          id: 2,
          url: "/home/customize",
          name: "定制开发"
        }, {
          id: 3,
          url: "/home/internetthings",
          name: "物联网开发"
        }, {
          id: 4,
          url: "/home/template",
          name: "快速建站"
        }, {
          id: 5,
          url: "/IDC",
          name: "IDC服务"
        }, {
          id: 6,
          url: "/home/server",
          name: "服务器租赁"
        }, {
          id: 7,
          url: "/home/domain",
          name: "域名注册及备案"
        }, {
          id: 8,
          url: "/home/ssl",
          name: "SSL证书"
        }, {
          id: 9,
          url: "/home/property",
          name: "知识产权"
        }, {
          id: 10,
          url: "/home/about/brief",
          name: "关于我们"
        }, {
          id: 11,
          url: "/my",
          name: "个人中心"
        }];
      } else {}
      // 友情链接
      cowContactList({
        action: "cowContactList",
        data: {
          cowContactForm: {
            type: "2"
          }
        }
      }).then(res => {
        this.mobileCowContactList = res.data.cowContactList;
      });
      cowContactList({
        action: "cowContactList",
        data: {
          cowContactForm: {
            type: "0"
          }
        }
      }).then(res => {
        this.mobileRelation = res.data.cowContactList[0];
      });
      queryImgList({
        action: "queryImgList"
      }).then(res => {
        this.mobileQueryImgList = res.data.cowImgList[0];
      });
    }
  },
  mounted() {
    this.mobileInit();
    this.getqueryCount();
    this.getselectUserInfoById();
    let token = localStorage.getItem("token");
    let details = JSON.parse(sessionStorage.getItem("home_nav_index"));
    if (details) {
      this.navIndex = details;
    }
    if (token !== null) {
      this.showLogin = false, this.showRegister = false;
      this.showpersonal = true;
      this.offer = "报价咨询";
      this.technology = "技术咨询";
      this.record = "咨询记录";
      this.resume = "投递简历";
      this.quit = "退出登录";
      this.personalId = 1;
    } else {
      this.personalId = 0;
      this.offer = "";
      this.technology = "";
      this.record = "";
      this.quit = "";
    }
    cowContactList({
      action: "cowContactList",
      data: {
        cowContactForm: {
          type: "2"
        }
      }
    }).then(res => {
      this.cowContactList = res.data.cowContactList;
    });
    cowContactList({
      action: "cowContactList",
      data: {
        cowContactForm: {
          type: "0"
        }
      }
    }).then(res => {
      this.relation = res.data.cowContactList[0];
    });
    queryImgList({
      action: "queryImgList"
    }).then(res => {
      this.queryImgList = res.data.cowImgList;
    });
    this.$nextTick(() => {
      const wow = new WOW({
        boxClass: "wow",
        // default
        animateClass: "animated",
        // default
        offset: 400,
        // default
        mobile: true,
        // default
        live: false
      });
      wow.init();
    });
    window.addEventListener("scroll", () => {
      const scrollTop = document.documentElement.scrollTop || document.body.scrollTop;
      if (scrollTop > 120) {
        this.isTop = true;
        this.backtopShow = true;
      } else {
        this.isTop = false;
        this.backtopShow = false;
      }
    });
    this.watchRoute(this.$route);
  },
  computed: {
    isMobileItemPicRoute() {
      // 根据您的路由实现修改此逻辑
      return this.$route.path.includes("/mobile/itempic");
    }
  }
};